<template>
    <div>
        <!-- Visualizar Anexos -->
        <div class="modal fade" id="verAnexosModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Anexos 
                            <span class="badge badge-secondary">
                                #{{ id }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-empty-state v-if="!anexos || !anexos.length" />

                        <div>
                            <div class="list-group">
                                <a :href="anexo.arquivo.temporary_url" class="list-group-item list-group-item-action" v-for="(anexo, iax) in anexos" :key="iax"
                                    target="_blank">
                                    {{ anexo.arquivo.st_titulo }}
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import AzEmptyState from '../../util/AzEmptyState.vue';

export default {
    data() { 
        return { 
            id: null, 
            anexos: null, 
        };
    },

    components: { 
        AzEmptyState, 
    },

    methods: { 
        abrir(model, id) { 
            this.id = id; 
            this.anexos = null;

            $('#verAnexosModal').modal('show');

            this.$util.load(this, {
                service: 'arquivos',
                func: 'links',
                parms: {
                    id: id,
                    type: model,
                },
                loadTo: res => { 
                    this.anexos = res;
                }
            });
            
        }

    }

}
</script>